module.exports = __webpack_public_path__ + "static/media/leaves-right.dbc7fad1.svg";